
import request from '../common'

export function iosLogin (params) {
  return request({
    url: '/sso/ios/login?noLoading',
    method: 'post',
    params
  })
}

export function androidLogin (params) {
  return request({
    url: '/sso/android/login?noLoading',
    method: 'post',
    params
  })
}

export function wxLogin (params) {
  return request({
    url: '/sso/wx/login',
    method: 'get',
    params
  })
}

export function wxLoginH5 (params) {
  return request({
    url: '/sso/wx/jsapi/login',
    method: 'get',
    params
  })
}

//发送验证码
export function registerSms (params) {
  return request({
    url: '/sms/getCode',
    method: 'get',
    params
  })
}

export function codeLogin (data) {
  return request({
    url: '/sso/code/login',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js